import AnimationFlame from '@/common/components/lottie/animation-flame';
import { colors } from '@/theme/colors';

import TrendingFire from '@/icons/trending-fire';

export interface ViewCountPillProps {
  viewCount: number;
  PRISTINE_HERO_PDP?: boolean;
  /** Needed to have different svg gradient IDs between desktop and mobile */
  svgGradientKey?: string;
}

export default function ViewCountPill({
  viewCount,
  PRISTINE_HERO_PDP,
  svgGradientKey,
}: ViewCountPillProps) {
  return PRISTINE_HERO_PDP ? (
    <div className="flex flex-shrink-0 items-center justify-center gap-[4px] rounded-[32px] bg-flexcar-neutral100 py-[4px] pl-[8px] pr-[12px] md:py-[8px] md:pl-[12px]">
      <TrendingFire
        className="h-[16px] w-[16px] flex-shrink-0 md:h-[20px] md:w-[20px]"
        gradientKey={svgGradientKey}
      />
      <p className="body3-tight font-bold leading-[18px] tracking-normal text-flexcar-neutral0 md:text-[14px] md:leading-[20px]">
        {viewCount} views
        <span className="font-medium md:font-normal"> last 24hr</span>
      </p>
    </div>
  ) : (
    <div
      className="flex items-center gap-[4px] rounded-[16px] border-[1.5px] border-neutral-100 py-[4px] pl-[6px] pr-[8px]"
      style={{
        background: `linear-gradient(93deg, ${colors.gradientViewCountPillPrimary} 0%, ${colors.gradientViewCountPillSecondary} 100%)`,
      }}
    >
      <AnimationFlame className="h-[20px] w-[20px]" autoplay={true} loop={true} />
      <div className="flex items-center gap-[3px]">
        <p className="body3-strong inline">{viewCount} views</p>
        <p className="body3 inline">last 24hr</p>
      </div>
    </div>
  );
}
